(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["BookDateModal"] && !Shopify.designMode) return;
  try {
    (function () {
              var button = document.getElementById('mtgCheckoutBtn');
              if (!button) return;

              button.addEventListener('click', function (event) {
                event.preventDefault();
                if (button.hasAttribute('disabled')) return;

                var variantId = button.getAttribute('data-variant-id');
                if (!variantId) return;

                var dateInput = document.getElementById('bookingDateInput');
                var timeslotInput = document.getElementById('bookingDateTimeslotInput');

                var dateValue = dateInput ? dateInput.value : '';
                var timeslotValue = timeslotInput ? timeslotInput.value : '';

                button.setAttribute('disabled', 'disabled');

                fetch('/cart/clear.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                })
                  .then(function (response) {
                    if (!response.ok) throw new Error('Failed to clear cart');

                    return fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                      },
                      body: JSON.stringify({
                        items: [
                          {
                            id: variantId,
                            quantity: 1,
                            properties: {
                              Date: dateValue,
                              Timeslot: timeslotValue,
                            },
                          },
                        ],
                      }),
                    });
                  })
                  .then(function (response) {
                    if (!response.ok) throw new Error('Failed to add item');
                    window.location.href = '/checkout';
                  })
                  .catch(function () {
                    button.removeAttribute('disabled');
                  });
              });
            })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["BookDateModalType3"] && !Shopify.designMode) return;
  try {
    (function () {
              var button = document.getElementById('mtgCheckoutBtn');
              if (!button) return;

              button.addEventListener('click', function (event) {
                event.preventDefault();
                if (button.hasAttribute('disabled')) return;

                var variantId = button.getAttribute('data-variant-id');
                if (!variantId) return;

                var dateInput = document.getElementById('bookingDateInput');
                var timeslotInput = document.getElementById('bookingDateTimeslotInput');

                var dateValue = dateInput ? dateInput.value : '';
                var timeslotValue = timeslotInput ? timeslotInput.value : '';

                button.setAttribute('disabled', 'disabled');

                fetch('/cart/clear.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                  },
                })
                  .then(function (response) {
                    if (!response.ok) throw new Error('Failed to clear cart');

                    return fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                      },
                      body: JSON.stringify({
                        items: [
                          {
                            id: variantId,
                            quantity: 1,
                            properties: {
                              Date: dateValue,
                              Timeslot: timeslotValue,
                            },
                          },
                        ],
                      }),
                    });
                  })
                  .then(function (response) {
                    if (!response.ok) throw new Error('Failed to add item');
                    window.location.href = '/checkout';
                  })
                  .catch(function () {
                    button.removeAttribute('disabled');
                  });
              });
            })();
  } catch(e) { console.error(e); }
})();

})();
